import { Component, inject } from '@angular/core';
import { AppUrls } from 'projects/bis-shared/src/lib/utility/appurls';
import { EnvironmentService } from '../../environment/environment.service';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'lib-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
  imports: [RouterLink],
})
export class UnauthorizedComponent {
  private environmentService = inject(EnvironmentService);

  homeUrl: string;
  appType: string;
  contactInfo = 'your supervisor';

  
 

  constructor() {
    this.homeUrl = AppUrls.home();

    if (this.environmentService.isExternalSite) {
      this.contactInfo = 'your organization’s online user administrator';
    } else {
      this.contactInfo = 'your supervisor';
    }
  }
}
